<template>
  <Typography
    variant="label"
    class="flex items-center"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <slot />
  </Typography>
</template>

<script>

import Typography from '../Typography'

export default {
  name: 'Label',

  inheritAttrs: false,

  components: { Typography }
}

</script>
